import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAfPAGvgblRFeDwdymoMPIrF0oZvOd_I3M",
  authDomain: "passport-creative.firebaseapp.com",
  projectId: "passport-creative",
  storageBucket: "passport-creative.firebasestorage.app",
  messagingSenderId: "278922316905",
  appId: "1:278922316905:web:f0f3ace7a21958f57d66f8",
  measurementId: "G-TK6ZQBFXVS"
};

// Initialize Firebase with error handling
let app, db, storage, auth, analytics;

try {
  console.log('Initializing Firebase with provided credentials');
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
  storage = getStorage(app);
  auth = getAuth(app);
  
  // Only initialize analytics in browser environment
  if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
  } else {
    analytics = { logEvent: () => {} };
  }
} catch (error) {
  console.warn('Firebase initialization error:', error.message);
  
  // Create fallback objects if initialization fails
  app = null;
  db = { collection: () => ({ doc: () => ({ get: async () => ({ exists: false, data: () => ({}) }) }) }) };
  storage = { ref: () => ({ put: async () => ({}) }) };
  auth = { currentUser: null };
  analytics = { logEvent: () => {} };
}

export { app, db, storage, auth, analytics };